<template>
  <div
    class="ranking-player-parts"
    :class="[
      `ranking-player-parts--${screenOrientationType}`,
      { 'ranking-player-parts--mode-gap': rankingViewMode === 'gap' },
      { 'ranking-player-parts--highlight': enabledHighlight() },
    ]"
  >
    <p class="ranking-player-parts__rank">
      <span>{{ rank ? rank : '--' }}</span>
    </p>

    <div class="ranking-player-parts__photo">
      <img :src="imgPath" alt="" />
      <button
        v-if="playerRadioData.car_no !== 0 || isPlaying"
        class="ranking-player-parts__radio"
        :class="{ 'ranking-player-parts__radio--playing': isPlaying }"
        @click="playRankingRadio"
      >
        <svg
          v-if="!isPlaying"
          class="ranking-player-parts__radio-icon"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.71313 0.666992H10.6853V7.24087H8.71313V0.666992Z" fill="white" />
          <path d="M12.6575 5.92578H15.9444V7.24056H12.6575V5.92578Z" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.05574 8.55566C7.32961 8.55566 6.74097 9.14431 6.74097 9.87044V23.0182C6.74097 23.7443 7.32961 24.333 8.05574 24.333H15.194C14.0316 23.1472 13.3148 21.5229 13.3148 19.7313C13.3148 17.0356 14.9374 14.7188 17.2592 13.7044V9.87044C17.2592 9.14431 16.6705 8.55566 15.9444 8.55566H8.05574ZM15.287 10.5278H8.71313V11.8426H15.287V10.5278ZM8.71313 13.1574H15.287V14.4722H8.71313V13.1574ZM9.37052 18.4165C9.73358 18.4165 10.0279 18.1222 10.0279 17.7591C10.0279 17.396 9.73358 17.1017 9.37052 17.1017C9.00745 17.1017 8.71313 17.396 8.71313 17.7591C8.71313 18.1222 9.00745 18.4165 9.37052 18.4165ZM12.6575 17.7591C12.6575 18.1222 12.3631 18.4165 12.0001 18.4165C11.637 18.4165 11.3427 18.1222 11.3427 17.7591C11.3427 17.396 11.637 17.1017 12.0001 17.1017C12.3631 17.1017 12.6575 17.396 12.6575 17.7591ZM10.0279 20.3886C10.0279 20.7517 9.73358 21.046 9.37052 21.046C9.00745 21.046 8.71313 20.7517 8.71313 20.3886C8.71313 20.0256 9.00745 19.7313 9.37052 19.7313C9.73358 19.7313 10.0279 20.0256 10.0279 20.3886ZM12.0001 21.046C12.3631 21.046 12.6575 20.7517 12.6575 20.3886C12.6575 20.0256 12.3631 19.7313 12.0001 19.7313C11.637 19.7313 11.3427 20.0256 11.3427 20.3886C11.3427 20.7517 11.637 21.046 12.0001 21.046Z"
            fill="white"
          />
          <path
            d="M16.6018 15.7871L23.0927 19.5735C23.4234 19.7664 23.4234 20.2443 23.0927 20.4372L16.6018 24.2236V15.7871Z"
            fill="white"
          />
        </svg>
        <svg
          v-else
          class="ranking-player-parts__radio-icon"
          width="36"
          height="19"
          viewBox="0 0 36 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.54306 5.32857C3.03015 4.84752 3.58877 4.44475 4.19906 4.13457C4.2577 4.10236 4.32222 4.08226 4.38877 4.07544C4.45533 4.06862 4.52258 4.07523 4.58654 4.09487C4.65049 4.11452 4.70986 4.1468 4.76111 4.1898C4.81236 4.23281 4.85447 4.28566 4.88492 4.34524C4.91538 4.40481 4.93357 4.46989 4.93841 4.53662C4.94326 4.60335 4.93466 4.67037 4.91314 4.73372C4.89161 4.79707 4.85759 4.85545 4.81308 4.90541C4.76858 4.95537 4.71451 4.99589 4.65406 5.02457C4.13683 5.28733 3.66326 5.62834 3.25006 6.03557C2.641 6.64443 2.1849 7.38895 1.91915 8.20812C1.65339 9.02729 1.58555 9.89777 1.72118 10.7482C1.8568 11.5987 2.19204 12.4049 2.69941 13.1007C3.20678 13.7966 3.87183 14.3624 4.64006 14.7516C4.75757 14.812 4.84641 14.9164 4.88716 15.0421C4.92791 15.1677 4.91726 15.3044 4.85754 15.4223C4.79782 15.5401 4.69389 15.6296 4.56844 15.671C4.443 15.7125 4.30625 15.7026 4.18806 15.6436C3.27892 15.1829 2.49189 14.5134 1.89147 13.6899C1.29104 12.8663 0.894316 11.9122 0.73381 10.9058C0.573303 9.89931 0.653584 8.86914 0.968072 7.8997C1.28256 6.93026 1.8223 6.04914 2.54306 5.32857ZM5.04006 7.03857C5.39406 6.68357 5.83006 6.39157 6.29406 6.18857C6.35435 6.16131 6.41945 6.14629 6.48558 6.14438C6.55172 6.14247 6.61758 6.1537 6.67934 6.17743C6.7411 6.20115 6.79754 6.2369 6.84539 6.2826C6.89323 6.3283 6.93153 6.38304 6.95807 6.44366C6.9846 6.50427 6.99884 6.56954 6.99996 6.63569C7.00109 6.70185 6.98907 6.76757 6.9646 6.82904C6.94014 6.89052 6.90372 6.94653 6.85745 6.99382C6.81118 7.04112 6.75598 7.07876 6.69506 7.10457C6.34252 7.25802 6.02118 7.47496 5.74706 7.74457C5.46531 8.02622 5.24182 8.36062 5.08933 8.72866C4.93685 9.09671 4.85837 9.49119 4.85837 9.88957C4.85837 10.2879 4.93685 10.6824 5.08933 11.0505C5.24182 11.4185 5.46531 11.7529 5.74706 12.0346C6.01777 12.3011 6.33589 12.5148 6.68506 12.6646C6.74527 12.6909 6.7997 12.7288 6.84526 12.7762C6.89081 12.8236 6.92658 12.8794 6.95054 12.9406C6.9745 13.0018 6.98617 13.0671 6.98489 13.1328C6.9836 13.1985 6.96939 13.2634 6.94306 13.3236C6.91673 13.3838 6.8788 13.4382 6.83143 13.4838C6.78406 13.5293 6.72819 13.5651 6.66699 13.5891C6.6058 13.613 6.54048 13.6247 6.47478 13.6234C6.40908 13.6221 6.34427 13.6079 6.28406 13.5816C5.82056 13.3817 5.39861 13.0968 5.04006 12.7416C4.66549 12.3671 4.36836 11.9224 4.16564 11.4331C3.96292 10.9437 3.85858 10.4192 3.85858 9.88957C3.85858 9.35989 3.96292 8.8354 4.16564 8.34605C4.36836 7.8567 4.66549 7.41308 5.04006 7.03857Z"
            fill="#00DBA6"
          />
          <path d="M15.5 0.884766H17V5.88477H15.5V0.884766Z" fill="#00DBA6" />
          <path d="M18.5 4.88477H21V5.88477H18.5V4.88477Z" fill="#00DBA6" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 6.88477C14.4477 6.88477 14 7.33248 14 7.88477V17.8848C14 18.437 14.4477 18.8848 15 18.8848H20.4293C19.5452 17.9829 19 16.7475 19 15.3848C19 13.3344 20.2341 11.5724 22 10.8008V7.88477C22 7.33248 21.5523 6.88477 21 6.88477H15ZM20.5 8.38477H15.5V9.38477H20.5V8.38477ZM15.5 10.3848H20.5V11.3848H15.5V10.3848ZM16 14.3848C16.2761 14.3848 16.5 14.1609 16.5 13.8848C16.5 13.6086 16.2761 13.3848 16 13.3848C15.7239 13.3848 15.5 13.6086 15.5 13.8848C15.5 14.1609 15.7239 14.3848 16 14.3848ZM18.5 13.8848C18.5 14.1609 18.2761 14.3848 18 14.3848C17.7239 14.3848 17.5 14.1609 17.5 13.8848C17.5 13.6086 17.7239 13.3848 18 13.3848C18.2761 13.3848 18.5 13.6086 18.5 13.8848ZM16.5 15.8848C16.5 16.1609 16.2761 16.3848 16 16.3848C15.7239 16.3848 15.5 16.1609 15.5 15.8848C15.5 15.6086 15.7239 15.3848 16 15.3848C16.2761 15.3848 16.5 15.6086 16.5 15.8848ZM18 16.3848C18.2761 16.3848 18.5 16.1609 18.5 15.8848C18.5 15.6086 18.2761 15.3848 18 15.3848C17.7239 15.3848 17.5 15.6086 17.5 15.8848C17.5 16.1609 17.7239 16.3848 18 16.3848Z"
            fill="#00DBA6"
          />
          <rect x="22" y="12.8848" width="5" height="5" fill="#00DBA6" />
          <path
            d="M33.4569 14.441C32.9698 14.922 32.4112 15.3248 31.8009 15.635C31.7423 15.6672 31.6778 15.6873 31.6112 15.6941C31.5447 15.7009 31.4774 15.6943 31.4135 15.6747C31.3495 15.655 31.2901 15.6227 31.2389 15.5797C31.1876 15.5367 31.1455 15.4839 31.1151 15.4243C31.0846 15.3647 31.0664 15.2996 31.0616 15.2329C31.0567 15.1662 31.0653 15.0992 31.0869 15.0358C31.1084 14.9725 31.1424 14.9141 31.1869 14.8641C31.2314 14.8142 31.2855 14.7736 31.3459 14.745C31.8632 14.4822 32.3367 14.1412 32.7499 13.734C33.359 13.1251 33.8151 12.3806 34.0809 11.5614C34.3466 10.7422 34.4144 9.87176 34.2788 9.02131C34.1432 8.17086 33.808 7.36465 33.3006 6.66878C32.7932 5.97291 32.1282 5.40718 31.3599 5.01796C31.2424 4.95758 31.1536 4.85314 31.1128 4.72746C31.0721 4.60179 31.0827 4.46509 31.1425 4.34724C31.2022 4.22939 31.3061 4.13996 31.4316 4.0985C31.557 4.05704 31.6938 4.06691 31.8119 4.12596C32.7211 4.58661 33.5081 5.25614 34.1085 6.07967C34.709 6.90321 35.1057 7.8573 35.2662 8.86376C35.4267 9.87022 35.3464 10.9004 35.0319 11.8698C34.7174 12.8393 34.1777 13.7204 33.4569 14.441ZM30.9599 12.731C30.6059 13.086 30.1699 13.378 29.7059 13.581C29.6457 13.6082 29.5806 13.6232 29.5144 13.6252C29.4483 13.6271 29.3824 13.6158 29.3207 13.5921C29.2589 13.5684 29.2025 13.5326 29.1546 13.4869C29.1068 13.4412 29.0685 13.3865 29.0419 13.3259C29.0154 13.2653 29.0012 13.2 29 13.1338C28.9989 13.0677 29.0109 13.002 29.0354 12.9405C29.0599 12.879 29.0963 12.823 29.1426 12.7757C29.1888 12.7284 29.244 12.6908 29.3049 12.665C29.6575 12.5115 29.9788 12.2946 30.2529 12.025C30.5347 11.7433 30.7582 11.4089 30.9107 11.0409C31.0631 10.6728 31.1416 10.2783 31.1416 9.87996C31.1416 9.48158 31.0631 9.0871 30.9107 8.71906C30.7582 8.35101 30.5347 8.01662 30.2529 7.73496C29.9822 7.46839 29.6641 7.25473 29.3149 7.10496C29.2547 7.07863 29.2003 7.0407 29.1547 6.99333C29.1092 6.94597 29.0734 6.89009 29.0495 6.8289C29.0255 6.7677 29.0138 6.70239 29.0151 6.63669C29.0164 6.57098 29.0306 6.50618 29.0569 6.44596C29.0833 6.38575 29.1212 6.33132 29.1686 6.28577C29.2159 6.24021 29.2718 6.20444 29.333 6.18048C29.3942 6.15652 29.4595 6.14485 29.5252 6.14614C29.5909 6.14742 29.6557 6.16163 29.7159 6.18796C30.1794 6.3878 30.6014 6.67271 30.9599 7.02796C31.3345 7.40247 31.6316 7.8471 31.8344 8.33645C32.0371 8.8258 32.1414 9.35029 32.1414 9.87996C32.1414 10.4096 32.0371 10.9341 31.8344 11.4235C31.6316 11.9128 31.3345 12.3565 30.9599 12.731Z"
            fill="#00DBA6"
          />
        </svg>
        <span class="ranking-player-parts__radio__gauge" v-if="isPlaying">
          <span
            class="ranking-player-parts__radio__gauge-meter"
            :style="`width:${gaugeWidth}%`"
          ></span>
        </span>
      </button>
    </div>

    <div class="ranking-player-parts__data">
      <div class="ranking-player-parts__tags">
        <div
          class="ranking-player-parts__tags-item"
          :class="[{ 'ranking-player-parts__tags-item--active': player.pitInWorking }]"
        >
          <span
            v-if="
              screenOrientationType.indexOf('landscape') !== -1 && lockOrientation === undefined
            "
            class="ranking-player-parts__tags-item-lp"
          >
            P
          </span>
          <span v-else class="ranking-player-parts__tags-item-ls"> PITIN </span>
          <i
            v-if="player.pitInCount > 0"
            v-html="player.pitInCount"
            class="ranking-player-parts__tags-count"
          />
        </div>

        <div
          v-if="
            player.valid &&
            enabledBestTime(player.bestTimeEnabled, player.lastLapTime, player.bestLapTime)
          "
          class="ranking-player-parts__tags-item ranking-player-parts__tags-item__best-time"
        >
          <span
            v-if="
              screenOrientationType.indexOf('landscape') !== -1 && lockOrientation === undefined
            "
            class="ranking-player-parts__tags-item-lp"
          >
            BT
          </span>
          <span v-else class="ranking-player-parts__tags-item-ls"> BestTime </span>
        </div>
      </div>

      <div class="ranking-player-parts__name">
        {{ player.number ? `#${player.number}` : '' }}
        <span class="name">{{ player.name[$i18n.locale] }}</span>
        <span class="abbreviation">{{ player.abbreviation }}</span>
      </div>

      <ranking-ots-parts
        class="ranking-player-parts__ots"
        :otsValue="playerTelemetryData.ots"
        :otsEnabled="playerTelemetryData.otsEnabled"
        :otsDisabledTime="playerTelemetryData.otsDisabledTime"
        :screenOrientationType="screenOrientationType"
      />

      <svg
        style="display: none"
        class="ranking-player-parts__ots"
        width="100"
        height="8"
        viewBox="0 0 100 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.2"
          d="M4.86133 0.5H89.5352C90.0219 0.5 90.5 0.627849 90.9217 0.870746L97.2224 4.5H13.2914C12.3181 4.5 11.3619 4.2443 10.5185 3.75851L4.86133 0.5Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M4.86133 0.5H88.7924C89.7657 0.5 90.7219 0.755698 91.5653 1.24149L97.2224 4.5H13.2914C12.3181 4.5 11.3619 4.2443 10.5185 3.75851L4.86133 0.5Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M99.3056 6.52778H12.22C11.0374 6.52778 9.87437 6.22576 8.84117 5.65035L1.38889 1.5H0L8.25478 6.35852C9.21557 6.92402 10.3101 7.22222 11.425 7.22222H100L99.3056 6.52778Z"
          fill="white"
        />
      </svg>
    </div>

    <div v-if="rankingViewMode === 'gap'" class="ranking-player-parts__select-data">
      <h5 class="ranking-player-parts__select-data__heading">
        Lap{{ player.lap }}・{{ player.sector }}
      </h5>

      <p class="ranking-player-parts__select-data__time">
        {{ player.valid && player.gapTime ? player.gapTime : '-------' }}
      </p>

      <svg
        class="ranking-player-parts__select-data__separator"
        width="6"
        height="11"
        viewBox="0 0 6 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.71008 0.801514L1.28988 10.1984" stroke="#4E4E4E" />
      </svg>

      <p class="ranking-player-parts__select-data__time">
        {{ player.valid ? trimmingLapTime(player.gapTimeInterval) : '-------' }}
      </p>
    </div>

    <div v-else-if="rankingViewMode === 'diff'" class="ranking-player-parts__select-data">
      <h5 class="ranking-player-parts__select-data__heading">
        Lap{{ player.lap }}・{{ player.sector }}
      </h5>

      <p class="ranking-player-parts__select-data__time">
        {{ player.valid && player.diffTime ? player.diffTime : '-------' }}
      </p>

      <svg
        class="ranking-player-parts__select-data__separator"
        width="6"
        height="11"
        viewBox="0 0 6 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.71008 0.801514L1.28988 10.1984" stroke="#4E4E4E" />
      </svg>

      <p class="ranking-player-parts__select-data__time">
        {{ player.valid ? trimmingLapTime(player.diffTimeInterval) : '-------' }}
      </p>
    </div>

    <div
      v-else-if="rankingViewMode === 'lastLapBestTime'"
      class="ranking-player-parts__select-data"
    >
      <p
        class="ranking-player-parts__select-data__time"
        :class="[
          {
            'ranking-player-parts__select-data__time--best-time': enabledLastLapHighlight(
              player.lastLapTime,
              player.bestLapTime,
            ),
          },
          {
            'ranking-player-parts__select-data__time--winner': enabledWinnerHighlight(
              player.winner,
            ),
          },
        ]"
      >
        {{ trimmingLapTime(player.lastLapTime) }}
      </p>

      <svg
        class="ranking-player-parts__select-data__separator"
        width="6"
        height="11"
        viewBox="0 0 6 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4.71008 0.801514L1.28988 10.1984" stroke="#4E4E4E" />
      </svg>

      <p class="ranking-player-parts__select-data__time">
        <span :class="{ 'ranking-player-parts__select-data__time--fastest': player.fastest }">{{
          trimmingLapTime(player.bestLapTime)
        }}</span>
        <br />
        (Lap{{ player.bestLap }})
      </p>
    </div>

    <svg
      class="ranking-player-parts__under-line"
      width="343"
      height="15"
      viewBox="0 0 343 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        v-if="enabledHighlightBottom() === 3"
        data-name="test1"
        d="M342 13.5H19.1422C16.49 13.5 13.9464 12.4464 12.0711 10.5711L2 0.5H0L11.364 11.864C13.0518 13.5518 15.341 14.5 17.7279 14.5H343L342 13.5Z"
        fill="url(#highlight_selected_in_battle)"
      />
      <path
        v-else-if="enabledHighlightBottom() === 2"
        data-name="test2"
        d="M342 13.5H19.1422C16.49 13.5 13.9464 12.4464 12.0711 10.5711L2 0.5H0L11.364 11.864C13.0518 13.5518 15.341 14.5 17.7279 14.5H343L342 13.5Z"
        fill="#00DBA6"
      />
      <path
        v-else-if="enabledHighlightBottom() === 1"
        d="M342 13.5H19.1422C16.49 13.5 13.9464 12.4464 12.0711 10.5711L2 0.5H0L11.364 11.864C13.0518 13.5518 15.341 14.5 17.7279 14.5H343L342 13.5Z"
        fill="url(#highlight_normal)"
      />
      <defs>
        <linearGradient
          id="highlight_selected_in_battle"
          x1="0"
          y1="13.9998"
          x2="343"
          y2="13.9998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00DBA6" stop-opacity="0" />
          <stop offset="1" stop-color="#00DBA6" />
        </linearGradient>

        <linearGradient
          id="highlight_normal"
          x1="-2.04442e-05"
          y1="15.0002"
          x2="343"
          y2="15.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.296875" stop-color="white" stop-opacity="0.3" />
          <stop offset="1" stop-color="white" stop-opacity="0.3" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import RankingOtsParts from '@/components/RaceVideoPage/RaceVideoRankingPane/parts/RankingOtsParts.vue'
import { RankingViewMode } from '@/components/RaceVideoPage/RaceVideoRankingPane.vue'
import { TelemetryDataType } from '@/store/stores/collectionModule/documents/telemetry/TelemetryDocument'
import { BattleDataType } from '@/components/RaceVideoPage/hook/useRanking'
import { PlayerLiveTimingDataType } from '@/store/stores/collectionModule/documents/liveTiming/PlayerLiveTiming'
import RadioDataDocument, {
  createEmptyRadioData,
} from '@/store/stores/collectionModule/documents/Radio/RadioDataDocument'
import { LockOrientationType } from '@/views/RaceVideoPage/RaceVideoPage.vue'

/**
 * レース動画再生画面 ランキング表示プレイヤーのコンポーネント
 */
export default defineComponent({
  name: 'RankingPlayerParts',
  components: {
    RankingOtsParts,
  },
  props: {
    /**
     * 画面固定
     */
    lockOrientation: {
      type: String as PropType<LockOrientationType>,
    },
    /**
     * Leader表示フラグ
     */
    leader: {
      type: Boolean,
      default: false,
    },
    /**
     * 選択中選手ID
     */
    selectedID: {
      type: String,
      default: '',
    },
    /**
     * 選手のライブタイミング情報
     */
    player: {
      type: Object as PropType<PlayerLiveTimingDataType>,
      required: true,
    },
    /**
     * 選手のテレメトリーデータ
     */
    playerTelemetry: {
      type: Object as PropType<TelemetryDataType>,
      required: true,
    },
    /**
     * ランキング
     */
    rank: {
      type: String,
      required: true,
    },
    /**
     * データ表示モード
     */
    rankingViewMode: {
      type: String as PropType<RankingViewMode>,
      required: true,
    },
    /**
     * バトルデータ
     */
    battleData: {
      type: Object as PropType<BattleDataType>,
      required: true,
    },
    /**
     * 無線データ
     */
    playerRadio: {
      type: Object as PropType<RadioDataDocument>,
      default: () => createEmptyRadioData(),
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 参加選手の情報一覧
     */
    img: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const enabledLeader = computed(() => props.leader)
    const playerData = computed(() => props.player)
    const playerTelemetryData = computed(() => props.playerTelemetry)
    const ranking = computed(() => props.rank)
    const selectedPlayerID = computed(() => props.selectedID)
    const battleList = computed(() => props.battleData)
    const viewModeData = computed(() => props.rankingViewMode)
    const playerRadioData = computed(
      (): RadioDataDocument => (props.playerRadio ? props.playerRadio : createEmptyRadioData()),
    )
    const isPlaying = computed(() => playerRadioData.value.state.isPlaying.value)
    const currentTime = computed(() => playerRadioData.value.state.currentTime.value)

    /**
     * 選手の顔写真ファイルのパス
     */
    const imgPath = computed({
      get: () => props.img || './assets/img/common/card/icon_player__null.svg',
      set: (val: string) => val,
    })

    /**
     * ハイライト表示有効化判定
     */
    const enabledHighlight = (): boolean => {
      if (viewModeData.value === 'lastLapBestTime') return false
      return (
        (enabledLeader.value && Number() === 1) ||
        (!enabledLeader.value && selectedPlayerID.value === playerData.value.id)
      )
    }

    /**
     * 下線部ハイライト表示有効化判定
     */
    const enabledHighlightBottom = (): number => {
      let inBattle = false
      let rt = 1
      if (viewModeData.value === 'lastLapBestTime') {
        return rt
      }
      inBattle = false
      Object.entries(battleList.value).forEach(([, value]) => {
        if (value.includes(Number(ranking.value))) {
          inBattle = true
        }
      })

      if (
        (!enabledLeader.value && selectedPlayerID.value === playerData.value.id && inBattle) ||
        (enabledLeader.value && Number(ranking.value) === 1 && inBattle)
      ) {
        // バトル中 && 選手ハイライト
        rt = 3
      } else if (
        (!enabledLeader.value && selectedPlayerID.value === playerData.value.id) ||
        (enabledLeader.value && Number(ranking.value) === 1)
      ) {
        // 選手ハイライト
        rt = 2
      }
      return rt
    }

    /**
     * 再生中の無線交信のプログレスの値を計算する
     */
    const gaugeWidth = computed(() => {
      if (!playerRadioData.value || !playerRadioData.value.duration) {
        return 0
      }
      return (currentTime.value / playerRadioData.value.duration) * 100
    })
    return {
      imgPath,
      enabledHighlight,
      enabledHighlightBottom,
      playerTelemetryData,
      gaugeWidth,
      playerRadioData,
      isPlaying,
    }
  },
  methods: {
    /**
     * ベストタイムアイコン表示判定
     */
    enabledBestTime(flag: boolean, lastLap: string, bestLap: string): boolean {
      return (
        (lastLap &&
          this.enabledLastLapHighlight(lastLap, bestLap) &&
          this.rankingViewMode === 'lastLapBestTime') ||
        (flag && this.rankingViewMode !== 'lastLapBestTime')
      )
    },
    /**
     * ラストラップがベストタイムか判定
     */
    enabledLastLapHighlight(lastLap: string, bestLap: string): boolean {
      return lastLap === bestLap && lastLap !== ''
    },
    /**
     * 全体1位か判定
     */
    enabledWinnerHighlight(winner: boolean): boolean {
      return this.player.lastLapTime !== '' && winner
    },
    /**
     * ラップタイムをトリミング
     * 空値の場合は空値用テキストを返却
     * @param time
     */
    trimmingLapTime(time: string): string {
      if (time === '') {
        return '-------'
      }

      // Last/bestTimeでは使用しない
      let plusTime = '+'
      if (!time.startsWith('-') && !time.includes(':')) {
        plusTime += time
        return plusTime
      }

      const trimLength = 8
      if (time.length <= trimLength) {
        return time
      }

      const returnTime = time.substring(0, trimLength - 1)

      if (!returnTime.endsWith('.')) {
        return returnTime
      }

      return time.substring(0, trimLength - 2)
    },
    /**
     * 無線交信データが選択された際に呼び出される。
     * 対象の無線交信データの再生処理を呼び出す。
     */
    playRankingRadio() {
      this.$emit('rankingRadioPlay', this.playerRadio)
    },
  },
})
</script>

<style lang="scss" scoped>
.ranking-player-parts {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  width: 100%;
  height: 5.333em;
  padding: 0.708em 0 0.708em 0.9167em;

  &__rank {
    width: 2.083em;
    margin-right: 0.41em;
    text-align: center;
    font-weight: 500;
    letter-spacing: 0.02em;

    span {
      font-size: 1.5em;
      line-height: 1.33;
    }
  }

  &__photo {
    position: relative;
    width: 4em;
    margin-right: 0.83em;
    overflow: hidden;

    img {
      border-radius: 0.16em;
    }
  }

  &__radio {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    background: rgba(#000, 50%);

    &-icon {
      width: 1.71em;
    }

    &__gauge {
      position: relative;
      width: 32px;
      height: 2px;
      background-color: #fff;
      overflow: hidden;

      &-meter {
        position: absolute;
        left: 0;
        top: 0;
        width: auto;
        height: 2px;
        background-color: $green-light;
      }
    }

    &--playing {
      .ranking-player-parts__radio-icon {
        width: 2.57em;
      }
    }
  }

  &__data {
    width: 8.333em;
    margin-right: 0.83em;
  }

  &__tags {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.5em;

    &-item {
      position: relative;
      display: inline-flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      padding: 0 0.625em;
      height: 2em;
      font-size: 0.567em;
      border: 1px solid #fff;
      color: #fff;
      border-radius: 0.625em;
      opacity: 0.2;

      &--active {
        opacity: 1;
        color: #86fbfb;
        border-color: #86fbfb;
      }

      &__best-time {
        color: $lime-green;
        border-color: $lime-green;
        opacity: 1;
      }
    }

    &-count {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.25em;
      height: 1.25em;
      color: $black;
      background: $white;
      border-radius: 50%;
      transform: translate(50%, -50%);
    }
  }

  &__name {
    display: block;
    width: 100%;
    height: 2em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 0.83em;
    line-height: 2;

    .abbreviation {
      display: none;
    }
  }

  &__ots {
    display: block;
    width: 100%;
  }

  &__select-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    width: 11.167em;
    height: 4em;
    gap: 0.41667em 0.2em;
    padding: 0.667em 0.4em;
    background: $black90;
    border-radius: 0.667em;

    &__heading {
      width: 100%;
      font-size: 0.833em;
      line-height: 1.6;
      letter-spacing: 0.04em;
      text-align: center;
      background: $black20;
      border-radius: 0.2em;
    }

    &__time {
      display: block;
      width: 5.5em;
      text-align: center;
      font-size: 0.75em;
      line-height: 1.2;

      &--best-time {
        color: $lime-green;
      }

      &--winner {
        color: #ff65df !important;
      }

      &--fastest {
        color: #ff65df !important;
      }
    }

    &__separator {
      display: block;
      width: 0.667em;
    }
  }

  &__under-line {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  &--highlight.ranking-player-parts--mode-gap {
    .ranking-player-parts {
      &__rank,
      &__name {
        color: $green-light;
      }

      &__select-data {
        background: rgba(0, 219, 166, 0.2);

        &__heading {
          background: rgba(0, 219, 166, 0.5);
        }

        &__time {
          color: #80ecd2;
        }

        &__separator path {
          stroke: #80ecd2;
        }
      }
    }
  }

  @media screen and (max-width: 359px) {
    padding: 0 4px 10px;

    .ranking-player-parts {
      &__rank {
        width: 34px;
        margin-right: 0;
        padding-left: 10px;

        span {
          font-size: 12px;
        }
      }

      &__photo {
        width: 32px;
        height: 32px;
        margin-right: 4px;

        img {
          border-radius: 2px;
        }
      }

      &__radio {
        gap: 3.5px;

        &-icon {
          width: 16px;
        }

        &__gauge {
          width: 22px;
          height: 1.5px;

          &-meter {
            height: 1.5px;
          }
        }

        &--playing {
          .ranking-player-parts__radio-icon {
            width: 24px;
          }
        }
      }

      &__data {
        width: 44px;
        margin-right: 2px;
      }

      &__tags {
        gap: 4px;

        &-item {
          padding: 0 4px;
          height: 14px;
          font-size: 8px;
          border-radius: 5px;

          span {
            display: none;
          }
        }

        &-count {
          font-size: 8px;
          transform: translate(50%, -50%);
        }
      }

      &__name {
        height: 19px;
        line-height: 20px;
        font-size: 10px;
        text-overflow: unset;
        overflow: visible;

        .name {
          display: none;
        }

        .abbreviation {
          display: initial;
        }
      }

      &__ots {
        display: block;
        width: 100%;
        height: 7px;
      }

      &__select-data {
        width: max(calc(100% - 150px), 100px);
        height: 48px;
        gap: 7px 3px;
        padding: 7px 4px;
        border-radius: 8px;

        &__heading {
          width: max(90%, 80px);
          font-size: 8px;
          border-radius: 2px;
        }

        &__time {
          width: 40px;
          font-size: 8px;
        }

        &__separator {
          width: 4px;
        }
      }

      &__under-line {
        bottom: 5px;
        left: 4px;
        width: calc(100% - 8px);
      }
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    padding: 0 4px 10px;

    .ranking-player-parts {
      &__rank {
        width: 34px;
        margin-right: 0;
        padding-left: 10px;

        span {
          font-size: 12px;
        }
      }

      &__photo {
        width: 32px;
        margin-right: 4px;

        img {
          border-radius: 2px;
        }
      }

      &__radio {
        gap: 3.5px;

        &-icon {
          width: 16px;
        }

        &__gauge {
          width: 22px;
          height: 1.5px;

          &-meter {
            height: 1.5px;
          }
        }

        &--playing {
          .ranking-player-parts__radio-icon {
            width: 24px;
          }
        }
      }

      &__data {
        width: 44px;
        margin-right: 2px;
      }

      &__tags {
        gap: 4px;

        &-item {
          padding: 0 4px;
          height: 14px;
          font-size: 8px;
          border-radius: 5px;

          &-lp {
            display: block;
          }

          &-ls {
            display: none;
          }
        }

        &-count {
          font-size: 8px;
          transform: translate(50%, -50%);
        }
      }

      &__name {
        height: 19px;
        line-height: 20px;
        font-size: 10px;
        text-overflow: unset;
        overflow: visible;

        .name {
          display: none;
        }

        .abbreviation {
          display: initial;
        }
      }

      &__ots {
        display: block;
        width: 100%;
        height: 7px;
      }

      &__select-data {
        width: 100px;
        height: 48px;
        gap: 7px 3px;
        padding: 7px 4px;
        border-radius: 8px;

        &__heading {
          width: 80px;
          font-size: 8px;
          border-radius: 2px;
        }

        &__time {
          width: 40px;
          font-size: 8px;
        }

        &__separator {
          width: 4px;
        }
      }

      &__under-line {
        bottom: 5px;
        left: 4px;
        width: calc(100% - 8px);
      }

      &--player {
        &-top {
          position: fixed;
        }

        &-second {
          margin-top: 5.333em;
        }
      }
    }
  }
}
</style>
